var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9999 11.5005C6.24297 11.5005 4 9.25775 4 6.50082C4 3.74389 6.24297 1.50092 8.9999 1.50092C11.7568 1.50092 13.9998 3.74389 13.9998 6.50082C13.9998 9.25775 11.7568 11.5005 8.9999 11.5005ZM8.9999 3.00087C7.07003 3.00087 5.49995 4.57077 5.49995 6.50082C5.49995 8.43069 7.07003 10.0006 8.9999 10.0006C10.9298 10.0006 12.4999 8.43069 12.4999 6.50082C12.4999 4.57077 10.9298 3.00087 8.9999 3.00087Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2495 22.4998H0.749977C0.335988 22.4998 0 22.1638 0 21.7498V18.2499C0 15.631 2.13091 13.5001 4.74979 13.5001H13.2496C15.8685 13.5001 17.9994 15.631 17.9994 18.2499V21.7498C17.9994 22.1638 17.6635 22.4998 17.2495 22.4998ZM1.49995 20.9999H16.4995V18.2499C16.4995 16.4581 15.0415 15.0001 13.2496 15.0001H4.74979C2.95798 15.0001 1.49995 16.4581 1.49995 18.2499V20.9999Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2496 11.7507H14.75C14.336 11.7507 14 11.4147 14 11.0007C14 10.5867 14.336 10.2507 14.75 10.2507H23.2496C23.6636 10.2507 23.9996 10.5867 23.9996 11.0007C23.9996 11.4147 23.6636 11.7507 23.2496 11.7507Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2498 15.7501C19.0577 15.7501 18.8658 15.677 18.7197 15.5302C18.4268 15.237 18.4268 14.7621 18.7197 14.4691L22.1896 10.9992L18.7197 7.52924C18.4268 7.23628 18.4268 6.76132 18.7197 6.46836C19.0127 6.1754 19.4876 6.1754 19.7808 6.46836L23.7806 10.4682C24.0736 10.7611 24.0736 11.2363 23.7806 11.5292L19.7808 15.5291C19.6338 15.677 19.4417 15.7501 19.2498 15.7501Z",
    fill: "#A6AAB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.d095ee7e.svg";
export { ForwardRef as ReactComponent };